module.exports = __webpack_public_path__ + "img/usability-desktop.271e5529.png";